import {useEffect, useState} from 'react';
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import MDAvatar from "components/MDAvatar";

import {getPhotoSource} from "api/requests"
import {readStream} from "readStream/readStream"

import { useTokenContext } from "App";
import { timeConverter } from 'timeConverter/timeConverter';

function Shop({ name, category, address, city, country, logoId, createdAt, updatedAt, noGutter, onEditClick }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [myStorage, setMyStorage] = useState({})
  const {token} = useTokenContext();
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)

  useEffect(() => {
    if(logoId){
      if(localStorage.getItem(logoId) === null){
        getPhotoSource(logoId, token)
        .then(response => {
          const reader = response.body.getReader();
          readStream(reader)
          .then(base64Response => {
            localStorage.setItem(logoId, base64Response)
            setNrPhotosDownloaded(nr => nr+1)
          })
          
        })
      }
    }
  }, [logoId]);

  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])

  return (
    <MDBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={3}
      mb={noGutter ? 0 : 1}
      mt={2}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          flexDirection={{ xs: "column", sm: "row" }}
          mb={2}
        >
          <MDBox 
            display="flex"
            justifyContent="left"
            alignItems="center"
            >
            {logoId in myStorage ?
            <MDAvatar src={'data:image/png;base64,'+myStorage[logoId]} alt={name} size="lg"/>
            :
            <MDAvatar src={null} alt={name} size="lg"/>
            }
            <MDTypography variant="button" fontWeight="medium" textTransform="capitalize" ml={2}>
              {name}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
            <MDButton variant="text" color={darkMode ? "white" : "dark"} onClick={onEditClick}>
              <Icon>edit</Icon>&nbsp;edit
            </MDButton>
          </MDBox>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="caption" color="text">
            Category:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium" textTransform="capitalize">
              {category}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="caption" color="text">
            Address:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium">
              {address}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="caption" color="text">
            City:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium">
              {city}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="caption" color="text">
            Country:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium">
              {country}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="caption" color="text">
            Created at:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium">
              {timeConverter(createdAt)}
            </MDTypography>
          </MDTypography>
        </MDBox>
        <MDBox mb={1} lineHeight={0}>
          <MDTypography variant="caption" color="text">
            Updated at:&nbsp;&nbsp;&nbsp;
            <MDTypography variant="caption" fontWeight="medium">
              {timeConverter(updatedAt)}
            </MDTypography>
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of Bill
Shop.defaultProps = {
  noGutter: false,
};


export default Shop;
